import React from "react";
import { useTheme } from "../common/ThemeContext";
import { ToggleLeft, ToggleRight } from "lucide-react";

const PlayerBasicCard = ({ player, onClick, onToggleActive }) => {
  const { isDarkMode } = useTheme();

  const isActive = player.player_enabled === true; // utiliser player_enabled (true seulement si explicitement true)
  const isDisabled = !isActive;

  return (
    <div
      onClick={isDisabled ? undefined : onClick}
      className={[
        "relative w-56 h-32 mt-6 bg-cover bg-center shadow-lg rounded-lg p-2 transition",
        isDisabled
          ? "opacity-60 cursor-not-allowed grayscale"
          : "cursor-pointer hover:scale-105",
        isDarkMode ? "bg-gray-700" : "bg-gray-200",
      ].join(" ")}
    >
      {/* Toggle Button */}
      <button
        onClick={(e) => {
          e.stopPropagation();
         onToggleActive?.(player.id, !isActive);
        }}
        className="absolute top-2 right-2"
      >
        {isActive ?(
          <ToggleRight className="text-green-500" size={22} />
        ) : (
          <ToggleLeft className="text-gray-400" size={22} />
        )}
      </button>

      {/* Avatar */}
      <div className="flex justify-center">
        <div className="w-20 h-20 -mt-8 rounded-xl overflow-hidden bg-gradient-to-r from-gray-400 to-blue-500 flex items-center justify-center text-white text-2xl font-bold">
          {player.profile_picture ? (
            <img
              src={`data:image/jpeg;base64,${player.profile_picture}`}
              alt={`${player.first_name} ${player.last_name}`}
              className="object-cover w-full h-full"
            />
          ) : (
            `${player.first_name.charAt(0)}${player.last_name.charAt(0)}`
          )}
        </div>
      </div>

      {/* Nom */}
      <h3
        className={`text-center text-base font-bold mt-3 ${
          isDarkMode ? "text-white" : "text-gray-800"
        }`}
      >
        {player.first_name} {player.last_name}
      </h3>
    </div>
  );
};

export default PlayerBasicCard;
